import styled from "styled-components";

export const CheckOutBox=styled.div` 
width: 70%;
border: 1px solid transparent;
margin: auto;

`;

export const Upbox=styled.div` 
margin-bottom: 1%;
`;

export const UpImg=styled.img` 
width: 200px;
margin: 8% 40% 1% 40%;
`;

export const Line=styled.div` 
width: 80%;
background-color: lightgray;
height: 1px;
`;

export const UpImg1 =styled.img` 
width: 150px;
margin-top: 10%;

`;

export const Div1=styled.div` 
margin-top: 2%;
color: gray;

`;

export const Flex =styled.div` 
display: flex;

`;

export const MainBill=styled.div` 
display: flex;
margin: 20px;
gap: 10px;
`;

export const ShipBox=styled.div` 
border: 1px solid lightgray;
width: 50%;
border-radius: 4px;

`;
export const BillBox=styled.div` 
width: 50%;
border: 1px solid lightgray;
border-radius: 4px;

`;

export const Input=styled.input` 
 margin:2% 1% 1% 10%;
 width: 75%;
 border: 1px solid lightgray;
 height: 25px;
`;

export const Head=styled.p` 
background-color: rgb(240,236,224);
margin-top: 2%;
height: 25px;
padding: 4px;
border-bottom: 2px solid lightgray;
`;

export const Label=styled.div` 
margin-right: 15%;
padding:3px;
border: 1px solid transparent;
flex: 2;
`;

export const Inbox=styled.div` 
 flex: 4;
`;

export const BoxFlex=styled.div` 
  display: flex;
`;

export const Green=styled.p` 
color:rgb(86,212,0);
margin-top: 2px;
`;

export const Method=styled.div` 
  display: flex;
`;

export const Inputradio=styled.input` 

`;


export const RadionBox=styled.div` 
 margin: 2%;
 cursor: pointer;
`;

export const TextBox=styled.div` 
 margin: 1%;
`;


export const Logoimg=styled.div` 
 display: flex;
 margin: 10px;
`;

export const Input1=styled.input` 
border: 1px solid lightgray;
width: 40%;
height: 25px;
margin:2% 1% 1% 0%;
`;
export const Input2=styled.input` 
 width: 60px;
 border: 1px solid lightgray;
height: 25px;
 margin: 2px;
 
 `;

 export const BoxFlex1=styled.div` 
 
 display: flex;
 `

 export const Select=styled.select` 
   margin-left: 36%;
   height: 25px;
   border: 1px solid lightgray;

 `;

 
export const Label1=styled.label` 
margin-left: 4px;
`;


export const Button=styled.button` 
margin-left: 4px;
background-color: rgb(129,165,85);
border:none;
height: 30px;
width: 150px;
border-radius: 4px;
margin: 3% 2% 4% 80%;
cursor: pointer;
`;

export const Input3=styled.input` 
margin-top: 15px;
`